import { selectPendingOnboarding } from "shared/utils/pendingOnboarding";

export interface OnboardingEntryInput {
  list: any;
  requestedId?: number;
}

export interface OnboardingEntry {
  selected: any | null;
  pending: any[];
  shouldLeave: boolean;
}

// A successful fetch is authoritative: nothing pending means the project is gone, not that it is still loading.
export const resolveOnboardingEntry = ({
  list,
  requestedId,
}: OnboardingEntryInput): OnboardingEntry => {
  const pending = selectPendingOnboarding(list);
  const selected =
    pending.find((project: any) => project?.project_id === requestedId) ||
    pending[0] ||
    null;

  return { selected, pending, shouldLeave: selected === null };
};
